<template>
  <div>
    <advertisement-detail-component v-if="isView" :selected-row="selectedRow" :page-type="pageType" :store-floor-seq="detail.storeFloorSeq" :store-seq="detail.storeSeq" :mediaType="detail.mediaType" :advertisementSeq="detail.advertisementSeq"></advertisement-detail-component>
  </div>
</template>

<script>
  import Vue from 'vue'

  import AdvertisementDetailComponent from "../Common/AdvertisementDetailComponent";
  import AdvertiserProxy from "@/proxies/AdvertiserProxy";

    export default {
      name: "MediaDetailPage",
      beforeCreate: function () {
        $cookies.set('id_token', this.$route.query.id_token);
        this.$store.dispatch('auth/check');
      },
      created: function () {
        this.detail.storeSeq = parseInt(this.$route.params.storeSeq);
        this.detail.advertisementSeq = parseInt(this.$route.params.advertisementSeq);
        this.detail.storeFloorSeq = parseInt(this.$route.params.storeFloorSeq);
        this.detail.mediaType = this.$route.query.media_type;
        this.pageType = this.$route.query.page_type;
        new AdvertiserProxy()
          .getAdvertiserMediaDetail(this.detail.advertisementSeq)
          .then((response) => {
            this.selectedRow = response.media;
            this.isView = true;
          });
      },
      components: {
        AdvertisementDetailComponent,
      },
      data() {
        return {
          isView: false,
          pageType: '',
          selectedRow: null,
          detail: {
            mediaType: '',
            storeSeq: 0,
            storeFloorSeq: '',
            advertisementSeq: '',
          },
        }
      },
    }
</script>

<style>


  .el-form-item {
    margin-bottom: 0px !important;
  }
</style>
